
const formatUnits = function(v: number): string {
    if (v) {
        if (v > 1e9) {
            return Math.round(v / Math.pow(10, 8)) / 10 + 'B'
        } else if (v > 1e6) {
            return Math.round(v / Math.pow(10, 5)) / 10 + 'M'
        } else if (v > 1e3) {
            return Math.round(v / Math.pow(10, 2)) / 10 + 'K'
        } else {
            return v.toString()
        }
    } else {
        return ''
    }
}

export const numbers = {
    formatUnit: formatUnits
}